import * as CONSTANTS from '../../constants';

const initialState = {
  initialData: {
    data: null,
    isLoading: false,
    error: null,
  },
  postSetupData: {
    data: null,
    isLoading: false,
    error: null,
  },
}

export default function (state = initialState, action){
  switch (action.type) {
    case CONSTANTS.UPDATE_ACCOUNT_SETUP_REQUEST:
      return { ...state, postSetupData: { isLoading : true, data: null, error: null } };
    case CONSTANTS.UPDATE_ACCOUNT_SETUP_SUCCESS:
      return {
        ...state, postSetupData: { data: action.payload || true, isLoading : false, error: null },
      };
    case CONSTANTS.UPDATE_ACCOUNT_SETUP_ERROR:
      return { ...state, postSetupData: { error: action.payload, data: null, isLoading: false } };

    case CONSTANTS.ACCOUNT_SETUP_TOKEN_REQUEST:
      return { ...state, initialData: { isLoading : true, data: null, error: null } };
    case CONSTANTS.ACCOUNT_SETUP_TOKEN_SUCCESS:
      return { ...state, initialData: { data: action.payload, isLoading : false, error: null } };
    case CONSTANTS.ACCOUNT_SETUP_TOKEN_ERROR:
      return { ...state, initialData: { error: action.payload, data: null, isLoading: false } };

    default:
      return state;
  }
}
